import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as departmentCategoryActions from "../../actions/departmentCategoryActions";

const DepartmentCategoryMultiSelect = ({
  value,
  onChange,
  departmentCategories,
  department,
  label,
  name,
  disabled,
  actions
}) => {
  const [options, setOptions] = useState([]);

  const handleChange = (selected) => {
    onChange(selected);
  };

  useEffect(() => {
    if (!departmentCategories.length) {
      actions.loadDepartmentCategories();
    }
  }, [departmentCategories, actions]);

  useEffect(() => {
    if (Array.isArray(department) && department?.length) {
      const optionsToReturn = departmentCategories
        .map((dc) => ({
          label: dc?.name,
          value: dc._id,
          deptValue: dc?.department?._id
        }))
        .filter((dc) => department?.some((d) => dc.deptValue === d))
        .sort((a, b) => {
          if (a.label > b.label) return 1;
          if (b.label > a.label) return -1;
          return 0;
        });

      const updatedSelectedValues =
        value?.filter((v) => optionsToReturn.some((opt) => opt.value === v)) ||
        [];

      setOptions(optionsToReturn);
      handleChange(updatedSelectedValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [department, departmentCategories]);

  const getValue = (val) => {
    if (Array.isArray(val) && val?.length) {
      return val.map((v) => ({
        label: departmentCategories.find((dc) => dc._id === v)?.name,
        value: v
      }));
    }
    return [];
  };

  return (
    <React.Fragment>
      <label
        className={`control-label ${!label ? "hidden" : ""}`}
        htmlFor={name}
        style={{ textTransform: "uppercase" }}
      >
        {label}
      </label>
      <Select
        isDisabled={disabled}
        id="service-select"
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder="Department Category"
        value={getValue(value)}
        options={options}
        onChange={handleChange}
        isMulti
      />
    </React.Fragment>
  );
};

DepartmentCategoryMultiSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  departmentCategories: PropTypes.array,
  department: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  actions: PropTypes.object
};

DepartmentCategoryMultiSelect.defaultProps = {
  departmentCategories: [],
  disabled: false
};

function mapStatesToProps(state) {
  return {
    departmentCategories: state.reducers.departmentCategories
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...departmentCategoryActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(DepartmentCategoryMultiSelect);
